<template>
  <div class="rightmain">
    <div>
      <p class="tLeft">
        <strong>{{ rightTitle }}</strong>
        <Course :name="getName(rightTitle)" />
      </p>
      <p @click="close" class="tRight">×</p>
      <hr class="hr" />
      <getTitle v-if="rightTitle === '智能标题'" />
      <GetAbstract v-if="rightTitle === '智能摘要'" />
      <GetErrorInfo ref="errorinfo" v-if="rightTitle === '智能纠错'" />
      <GetOriginal ref="originalInfo" v-if="rightTitle === '原创检测'" />
      <GetProhibited ref="GetProhibited" v-if="rightTitle === '违规检测'" />
      <SetOriginal ref="SetOriginal" v-if="rightTitle === '智能换词'" />
      <GetReinvent ref="GetReinvent" v-if="rightTitle === '智能改写'" />
      <GetSentence ref="GetSentence" v-if="rightTitle === '整句原创'" />
    </div>
  </div>
</template>

<script>
import getTitle from "../components/edit/GetTitle";
import GetAbstract from "../components/edit/GetAbstract";
import GetErrorInfo from "../components/edit/GetErrorInfo";
import GetOriginal from "../components/edit/GetOriginal";
import GetProhibited from "../components/edit/GetProhibited";
import SetOriginal from "../components/edit/SetOriginal";
import GetReinvent from "../components/edit/GetReinvent";
import GetSentence from "../components/edit/GetSentence";
import findWords from "../assets/script/utils/findWords";
import Course from "@/components/share/Course";

export default {
  name: "RightContent",
  props: {
    contentHeight: {
      type: Number,
      default: 0
    }
  },
  components: {
    getTitle,
    GetAbstract,
    GetErrorInfo,
    GetOriginal,
    GetProhibited,
    SetOriginal,
    GetReinvent,
    Course,
    GetSentence
  },
  data() {
    return {
      getid: null
    };
  },
  mounted() {
    this.getid = setInterval(() => {
      let getBox = document.getElementsByClassName("rightmain")[0];
      if (getBox) {
        clearInterval(this.getid);
        this.fixEditorHeight(this.contentHeight);
      }
    }, 500);
  },
  watch: {
    contentHeight: {
      handler: function(val) {
        this.fixEditorHeight(val);
      }
    }
  },
  computed: {
    rightShow: {
      get() {
        return this.$store.state.contents.rightShow;
      },
      set(val) {
        this.$store.state.contents.rightShow = val;
      }
    },
    rightTitle: {
      get() {
        return this.$store.state.contents.rightTitle;
      },
      set(val) {
        this.$store.state.contents.rightTitle = val;
      }
    }
  },
  methods: {
    fixEditorHeight(newContentHeight) {
      let toolbar = document.querySelector(".el-header");

      let editorToolbarHeight = 0;
      if (toolbar !== null && toolbar !== undefined) {
        editorToolbarHeight = toolbar.offsetHeight;
      }
      let editorStatusBarHeight = 0;
      let realHeight =
        newContentHeight - editorToolbarHeight - editorStatusBarHeight;
      let getBox = document.getElementsByClassName("rightmain")[0];
      getBox.style.height = realHeight + "px";
      getBox.style.backgroundColor = "#fff";
    },
    getName(name) {
      if (name === "智能标题") return "intelligence";
      if (name === "智能摘要") return "abstract";
      if (name === "整句原创") return "wycUrl";
      if (name === "智能纠错") return "error";
      if (name === "原创检测") return "oriCheck";
      if (name === "违规检测") return "violation";
      if (name === "智能换词" || name === "智能改写") return "replaceWyc";
    },
    close() {
      this.rightShow = false;
      findWords.closeAllHighlight();
      // if (this.rightTitle === "智能纠错") {
      //   this.$nextTick(() => {
      //     this.$refs.errorinfo.clear();
      //   });
      // }
      // if (this.rightTitle === "原创检测") {
      //   this.$nextTick(() => {
      //     this.$refs.originalInfo.clear();
      //   });
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.rightmain {
  background-color: #ffffff;
  position: fixed;
  box-shadow: -1px 0px 10px rgba(178, 184, 206, 0.9);
  top: 60px;
  width: 480px;
  right: 0;
  height: calc(100vh - 60px);
  .tLeft {
    display: inline-block;
    line-height: 40px;
    margin-left: 15px;
    font-size: 14px;
  }
  .tRight {
    float: right;
    font-size: 25px;
    cursor: pointer;
    margin-right: 5px;
    color: #b5a8a8;
    margin-top: 5px;
  }
  .hr {
    border: 1px solid #d3d7de;
    border-right: 0px;
    border-bottom: 0px;
    border-left: 0px;
  }
}
.app-course {
  color: #216bed;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-left: 10px;
  margin-top: 12px;
  margin-right: 0px;
}
</style>
